import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-lista-img",
  templateUrl: "./lista-img.component.html",
  styleUrls: ["./lista-img.component.scss"],
})
export class ListaImgComponent implements OnInit {
  @Input() elements: any[] = [];
  @Input() cols: number = 4;
  distinctElements: any[];

  constructor() {}

  ngOnInit() {
    this.distinctElements = this.filterDistinctElements(this.elements);
  }

  private filterDistinctElements(elements: any[]): any[] {
    const distinctNamesSet = new Set<string>();
    return elements.filter((el) => {
      const isAdd: boolean = el.name?.toLowerCase()?.includes("adicional");
      return (
        el.type !== "MEDIA" ||
        this.isDistinctName(el.label, distinctNamesSet, isAdd)
      );
    });
  }

  private isDistinctName(
    label: string,
    distinctNamesSet: Set<string>,
    isAdd: boolean
  ): boolean {
    if (!distinctNamesSet.has(label) || isAdd) {
      distinctNamesSet.add(label);
      return true;
    }
    return false;
  }
}
